﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class PosOrderItem(
    val id: String = "",
    val tenant_id: String = "",
    val order_id: String,
    val item_id: String? = null,
    val manual_name: String? = null,
    val quantity: Int = 1,
    val price_at_time: Double,
    val total_price: Double,
    val created_at: String = ""
)

